import { FunctionComponent, useEffect, useState } from 'react';
import { Button, SelectMultiple, Select, Table, TableRow, TableCell } from '../../tailwindcomponents';
import { Typography, Input } from '../../tailwindcomponents';
import taskApi from '../../api/tasks';
import lineApi from '../../api/line';
import { HandoverReportSearchObj } from '../../types/line';

type IssueHistoryProps = {
    setLoading: (loading: boolean) => void;
}
const departmentTypes = [
    { id: 0, name: "Line" },
    { id: 1, name: "Lite" },
];

const IssueHistory: FunctionComponent<IssueHistoryProps> =({ setLoading }) => {
    const [allTails, setAllTails] = useState<string[]>([]);
    const [selectedTailNumber, setSelectedTailNumber] = useState<string>("");
    const [searchText, setSearchText] = useState("");
    const [selectedDepartments, setSelectedDepartments] = useState<number[]>([]);
    const [allIsues, setAllIsues] = useState(Array<HandoverReportSearchObj>());
    const [filteredIssues, setFiltereissues] = useState(Array<HandoverReportSearchObj>());

    useEffect(() => {
        setLoading(true);
        taskApi.GetAllTailNumbers().then(res => {
            setAllTails(res.data);
            setLoading(false);
        })
    }, []);

    useEffect(() => {
        refresh();
    }, [selectedDepartments, selectedTailNumber]);

    useEffect(() => {
        filterByText(searchText, allIsues);
    }, [searchText]);

    const filterByText = (txt: string, tempAllIssues: Array<HandoverReportSearchObj>) => {
        if (txt.length === 0) {
            setFiltereissues(tempAllIssues);
        } else {
            setFiltereissues(tempAllIssues.filter(s => s.issue.toUpperCase().includes(txt.toUpperCase())));
        }
    }

    const refresh = () => {
        const tempDepartments: string[] = [];
        selectedDepartments.map(row => (
            tempDepartments.push(departmentTypes[row].name)
        ));
        setLoading(true);
        lineApi.GetHandoverReportsByTail(selectedTailNumber, tempDepartments).then(res => {
            if (res.status) {
                setAllIsues(res.data);
                filterByText(searchText, res.data);
            }
            setLoading(false);
        });
    }

    const generateTableBody = (row: HandoverReportSearchObj, index: number) => {
        return (
            <TableRow key={`${row.tail_number}-${row.created_date}-${index}`}>
                <TableCell>{index}</TableCell>
                <TableCell>{row.created_date_text}</TableCell>
                <TableCell>{row.tail_number}</TableCell>
                <TableCell>{row.issue}</TableCell>
                <TableCell>{row.created_by_name}</TableCell>
                <TableCell>{row.department}</TableCell>
            </TableRow>
        )
    }
    const onClearFilters = () => {
        setSelectedDepartments([]);
        setSelectedTailNumber("");
        setSearchText("");
    }
    return (
        <div>
            <div className="flex flex-wrap items-end gap-2 mb-2">
                <div className="w-full sm:w-1/2 md:w-1/4 lg:w-1/6">
                    <Select
                        width={100}
                        widthPercentage
                        filter_by_text="Tail number"
                        onSelectedItem={(e: any) => setSelectedTailNumber(e.target.value)}
                        options={allTails}
                        selectedItem={selectedTailNumber}
                    />
                </div>
                <div className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4">
                    <Input
                        multiline={false}
                        label_text="Search by text"
                        help_text=""
                        type="text"
                        value={searchText}
                        width={100}
                        onTextChange={(value: string) => setSearchText(value)}
                    />
                </div>
                <div className="w-full sm:w-1/2 md:w-1/4 lg:w-1/6">
                    <SelectMultiple
                        optionsObject={departmentTypes}
                        onSelectedItem={(e: any) => setSelectedDepartments(e.target.value)}
                        selectedItems={selectedDepartments}
                        width={100}
                        widthPercentage
                        filter_by_text={"Filter by Departments"}
                    />
                </div>
                <Button variant="text" color='primary' onClick={() => { onClearFilters() }}>Clear filters</Button>
            </div>
            <div className="flex flex-wrap justify-center">
                <Typography variant={"h4"} text={"issues(" + filteredIssues.length + ")"} align='center' margin={[0, 0, 1, 0]} />
            </div>
            <div>
                <Table
                    headers={["Created Date", "Tail Number", "Issue", "Created By", "Department"]}
                    rows={filteredIssues}
                    generateBody={(row: any, index: number) => generateTableBody(row, index)}
                    pagination={true}
                    defaultRowsPerPage={100}
                    skipIndexCol={false}
                />
            </div>
        </div>
    )
};
export default IssueHistory;